import { IInvoiceFr } from '../../types/invoice-fr'
import { Document, View, Page } from '@react-pdf/renderer'
import { styles } from './styles'
import Footer from './components/Footer'
import Header from './components/Header'
import DiagnosticInfo from './components/DiagnosticInfo'
import SenderInfo from './components/SenderInfo'
import ReceiverInfo from './components/ReceiverInfo'
import PatientInfo from './components/PatientInfo'
import InvoiceDetails from './components/InvoiceDetails'

const Invoice = ({ invoiceData }: { invoiceData: IInvoiceFr }) => {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Header invoiceData={invoiceData} />
        <View style={styles.pageContainerInner}>
          <DiagnosticInfo invoiceData={invoiceData} />
          <View style={[styles.flexRowContainer, styles.mYmediumContainer]}>
            <SenderInfo invoiceData={invoiceData} />
            <ReceiverInfo invoiceData={invoiceData} />
          </View>
          <PatientInfo invoiceData={invoiceData} />
          <InvoiceDetails invoiceData={invoiceData} />
        </View>
        <Footer />
      </Page>
    </Document>
  )
}

export default Invoice
